// extracted by mini-css-extract-plugin
export default {"seo-data":"_2J2BI","seoData":"_2J2BI"};